import React, { useRef, useCallback, useState, useContext, useEffect } from "react";
import { AppContext } from "../../src/util/appContext";
import AttachmentIcon from '../images/attach.svg';
import {  getCookie } from '../util/cookieActions';
import StaticLabels from "../util/staticLabels.json";
var classNames = require('classnames');
const AttachmentFile = ({ fileInputRef, onFilePick }) => {
const context = useContext(AppContext);
var displayNoneClass=classNames({
  displayNone: true,
  attachmentDiv:true
});
var attachClass = classNames({
    displayNone: true,
    attachbtn:true
  });
    return (
        <div className={displayNoneClass}>
            <input className="send-box-preview"
                   ref={fileInputRef}
                   type="file"
                   style={{ display: 'none' }}
                   accept=".csv,.doc,.docx,.dot,.ics,.pdf,.pps,.ppsx,.ppt,.pptx,.rtf,
                    .sxc,.sxi,.sxw,.txt,.xls,.xlsx,
                    .vsd,.gif,.jpeg,.jpg,.png,
                    .mp3,.ogg,.wav,
                    .avi,.mov,.mpeg,.mpg,.mp4"
                   onChange={onFilePick}
            /> 
            <button
                type="button"
                className={attachClass}
                onClick={() => fileInputRef.current?.click()}
                aria-label="Attach file"
            >
                <span className={`attachFileTooltip`}>{window.config.language?StaticLabels[window.config.language].attachFileTooltip:StaticLabels["en"].attachFileTooltip}</span>
               <img
                    src={AttachmentIcon}
                    alt="Attach"
                    className="attach-icon"
                />
                
            </button>
        </div>
    );
}

export default AttachmentFile;